module.exports = function(){
	// return "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
	return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};